module.exports = {
  title: "辽宁省沈抚改革创新示范区智慧招商平台",

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,
  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  showSettings: false
};
